import { apiGet, apiPost } from '../client';
import type { CrashEvent } from '@/types/api';

export interface CancelResult {
  status: string;
  crash_event_id: number;
}

/** The caller's own crashes still inside the cancel window — feeds the banner. */
export function getActiveCrashes(): Promise<CrashEvent[]> {
  return apiGet<CrashEvent[]>('/crash/active');
}

/** Owner (or admin/fleet) confirms it was a false alarm. 409 once the window elapsed. */
export function cancelCrash(crashId: number): Promise<CancelResult> {
  return apiPost<CancelResult>(`/crash/${crashId}/cancel`);
}

/** The one-time link from the alert SMS — no auth. */
export function cancelCrashByToken(token: string): Promise<CancelResult> {
  return apiPost<CancelResult>(`/crash/cancel/${encodeURIComponent(token)}`, { anonymous: true });
}
